<template>
  <event-list
    :title="title"
    :types="types"
  ></event-list>
</template>

<script>
import EventList from '@/components/EventList'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    EventList,
  },
  data: () => ({
    title: 'Holistic Retreats',
    types: ['retreat']
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
